import { ButtonHTMLAttributes, ReactNode } from "react";
import { cx } from "@app/shared/utils/cx";
import styles from "./IconButton.module.css";

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ReactNode;
  "aria-label": string;
  surface?: boolean;
};

export const IconButton = ({ icon, surface = false, className, ...rest }: IconButtonProps) => (
  <button type="button" className={cx(styles.iconButton, surface && styles.surface, className)} {...rest}>
    {icon}
  </button>
);
